import { Controller } from "@hotwired/stimulus"

// Submits a form and syncs the input value to a hidden field on change.
// Usage:
//   data-controller="date-sync-submit"
//   data-action="change->date-sync-submit#sync"
//   data-date-sync-submit-form-value="coverage_form"
//   data-date-sync-submit-hidden-value="hidden_start_date"
export default class extends Controller {
  static values = { form: String, hidden: String }

  sync() {
    const form = document.getElementById(this.formValue)
    const hidden = document.getElementById(this.hiddenValue)
    if (form) form.requestSubmit()
    if (hidden) hidden.value = this.element.value
  }
}
